import React, { useEffect } from "react";
import { Form, FormProps, Icon, Input } from "semantic-ui-react";
import { useIntl } from "react-intl";

type EmployeeTokenProps = {
  id?: string;
  disabled?: boolean;
  tabIndex?: number,
  employeeCode: string,
  employeeName: string,
  onEnterToken: (x: string) => void,
  onClearToken: () => void,
  onChangeCodeText?: (x: any) => void,
  placeholder: string,
  fluid?: boolean,
  inputStyle?: any,
  notWidth100?: boolean
  error: any;
  onClick?: any;
  loading: boolean;
  size?: FormProps["size"]
  autoComplete?: string;
}

const DEFAULT_PROPS = {
  id: "",
  disabled: false,
  tabIndex: 0,
  employeeCode: "",
  employeeName: "",
  onEnterToken: () => {},
  onClearToken: () => {},
  onChangeCodeText: () => {},
  error: false,
  loading: false,
  placeholder: "",
  fluid: false,
  inputStyle: {},
  notWidth100: false
}

const EmployeeToken = (propsParam: EmployeeTokenProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const intl = useIntl();
  const [employeeCode, setEmployeeCode] = React.useState("");
  const [employeeName, setEmployeeName] = React.useState("");

  useEffect(() => {
    setEmployeeCode(props.employeeCode);
  }, [props.employeeCode]);

  useEffect(() => {
    setEmployeeName(props.employeeName);
  }, [props.employeeName]);

  const changeToken = (data: any) => {
    setEmployeeCode(data.value);
  };

  const enterToken = () => {
    props.onEnterToken(employeeCode);
  };

  const clearToken = (e: any) => {
    if (props.disabled) {
      return;
    }
    props.onClearToken();
    setEmployeeCode("");
    setEmployeeName("");
    e.stopPropagation();
  };

  return (
    <Form size={props.size} style={{ ...(!props.notWidth100 && { width: "100%" }) }}>
      <Form.Field error={props.error} style={{ padding: 0 }}>
        <Input
          id={props.id ? `${props.id}-Input` : `EmployeeToken-Input`}
          disabled={props.disabled}
          style={{
            display: employeeName ? "none" : "",
            ...props.inputStyle,
            marginRight: 0,
          }}
          type="password"
          autoComplete={props.autoComplete}
          value={employeeCode ? employeeCode : ""}
          placeholder={props.placeholder || "ระบุ Employee code"}
          onChange={(event, data) => {
            props.onChangeCodeText(data);
            changeToken(data);
          }}
          onClick={props.onClick}
          onKeyPress={(event: any, data: any) => {
            if (props.disabled) {
              return;
            }
            if (event.key === "Enter") {
              enterToken();
            }
          }}
          loading={props.loading}
          icon={
            employeeName && employeeCode ? (
              <Icon name="delete" link onClick={clearToken} />
            ) : undefined
          }
          tabIndex={props.tabIndex}
          fluid={props.fluid}
        />
        <Input
          id={props.id ? `${props.id}-Output` : `EmployeeToken-Output`}
          readOnly
          disabled={props.disabled}
          autoComplete={props.autoComplete}
          style={{ display: employeeName ? "" : "none", ...props.inputStyle }}
          value={employeeName ? employeeName : ""}
          icon={<Icon name="delete" link onClick={clearToken} />}
          fluid={props.fluid}
        />
      </Form.Field>
    </Form>
  );
};

export default React.memo(EmployeeToken);
